module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"interviewOnline":"Online interview","officeInterview":"In-person interview","online_interview":"Virtual interview","video_call":"Video call","office_interview":"Office meeting","uploaded_video":"Video file"}}')
  delete Component.options._Ctor
}
